import { HasAccess } from '@permify/react-role';
import { Button, Col, Row, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { getCookie } from '../../../services/cookies';

const ExamButtons = ({
  handleSave,
  updateLaboratoryExamsButton,
  handleDoctorSave,
  disableForm,
  readOnly = false,
  isVinculating,
  loading,
  form,
  inputs,
  patient,
  fromExternal,
  isPermittedRole,
  isGroupedExams,
  handleSaveAllExams,
  handleFinishAllExams,
  allExams,
  getTranslationKey,
  downloadReport,
}) => {
  const roles = getCookie('roles');
  const { t } = useTranslation();
  const isExamPsychological = inputs.department_id === 2;

  if (fromExternal) {
    const showButtons = (roles.includes('doctor') && !isExamPsychological) || (roles.includes('equipo_psicologia') && isExamPsychological);
    if (!showButtons) {
      return null;
    }
  }

  const showFinalizeButton = !fromExternal;

  const downloadReportButton = (inputs.state === 'done' || (isGroupedExams && allExams?.every(exam => exam.inputs?.state === 'done'))) && 
    <Col xxl={1} lg={2} md={2} sm={2} xs={24}>
      <Tooltip
        title="Descargar Informe"
        color="#223A70"
      >
        <Button
          className="cmt-button secondary outline pl-5"
          type="secondary"
          icon={<span className="icon-system-download" />}
          size={"large"}
          onClick={downloadReport}
        />
      </Tooltip>
    </Col>

  return (
    (roles.includes('doctor') || roles.includes('direccion_medica')) ?
      <Row justify="end" className='mb-50' gutter={[15, 10]}>
        <Col lg={fromExternal ? 24 : 6} xs={fromExternal ? 24 : 12}>
          <Button
            className="cmt-button primary"
            type="primary"
            size="large"
            onClick={isGroupedExams ? handleSaveAllExams : handleDoctorSave}
            disabled={readOnly || loading.finish || loading.save}
          >
            {
              t(`examPage.buttons.${getTranslationKey('save')}`)
            }
          </Button>
        </Col>
        {downloadReportButton}
      </Row>
      :
      <Row justify={patient?.exam_type === 'laboratory' ? "space-around" : 'end'} className='mb-50' gutter={[15, 10]}>
        <Col lg={fromExternal ? 24 : 4} xs={fromExternal ? 20 : 12} offset={inputs.state !== 'inProgress' && 6}>
          <HasAccess
            roles={['super_usuario', 'equipo_medico', 'equipo_psicologia', 'equipo_medico_externo']}
            permissions='save-exam'
          >
            <Button
              className="cmt-button primary outline"
              type="primary"
              size="large"
              onClick={isGroupedExams ? handleSaveAllExams : handleSave}
              disabled={disableForm || isVinculating || loading.finish || loading.save || !isPermittedRole}
            >
              {
                t(`examPage.buttons.${getTranslationKey('save')}`)
              }
            </Button>
          </HasAccess>
        </Col>
        {
          (showFinalizeButton
            && (
              (!isGroupedExams && (inputs.state === 'inProgress' || inputs.state === 'done'))
              || (allExams?.some(exam => (exam.state === 'inProgress' || exam.state === 'done')))
            )
            && (!(inputs.state === 'done' && roles.includes('equipo_medico_externo')))
          ) &&
          <Col lg={fromExternal ? 24 : 6} xs={fromExternal ? 24 : 12} className="mt-lg-0 mt-md-15 mt-sm-15 mt-xs-15">
            <HasAccess
              roles={['super_usuario', 'equipo_medico', 'equipo_psicologia', 'equipo_medico_externo']}
              permissions='finalize-exam'
            >
              <Button
                className="cmt-button primary"
                type="primary"
                size="large"
                onClick={() =>
                  isGroupedExams ? handleFinishAllExams() : form.submit()
                }
                disabled={disableForm || isVinculating || loading.finish || loading.save || !isPermittedRole}
              >
                {
                  t(`examPage.buttons.${getTranslationKey('finish')}`)
                }
              </Button>
            </HasAccess>
          </Col>
        }
        {downloadReportButton}
      </Row>
  )
};

export default ExamButtons;
